import React from 'react';
import Reveal from './Reveal';

/**
 * Minimal editorial heading: small index label, hairline that draws itself,
 * then a display title that rises out of a mask.
 * `tone="light"` for royal-blue backgrounds.
 */
export default function SectionHeading({
  index,
  eyebrow,
  title,
  lede,
  align = 'left',
  tone = 'dark',
  className = '',
}) {
  const light = tone === 'light';
  const centered = align === 'center';
  const lines = String(title).split('\n');

  return (
    <Reveal className={`flex max-w-3xl flex-col ${centered ? 'mx-auto items-center text-center' : 'items-start'} ${className}`}>
      {(eyebrow || index) && (
        <div className={`flex items-center gap-4 ${centered ? 'justify-center' : ''}`}>
          {index && (
            <span className={`text-[12px] tracking-wider2 ${light ? 'text-gold/70' : 'text-gold-600'}`}>
              {index}
            </span>
          )}
          <span className={`rule-draw h-px w-10 ${light ? 'bg-gold/50' : 'bg-gold/45'}`} />
          {eyebrow && (
            <span
              className={`text-[12px] font-medium uppercase tracking-luxe ${
                light ? 'text-cream/80' : 'text-royal/70'
              }`}
            >
              {eyebrow}
            </span>
          )}
        </div>
      )}

      <h2
        className={`mt-6 font-display text-[2.1rem] leading-[1.02] sm:text-[2.9rem] lg:text-[3.4rem] ${
          light ? 'text-cream' : 'text-royal'
        }`}
      >
        {lines.map((line, i) => (
          <span key={line} className={`mask ${i === 1 ? 'mask-d1' : i === 2 ? 'mask-d2' : ''}`}>
            <span>{line}</span>
          </span>
        ))}
      </h2>

      {lede && (
        <p
          className={`mt-6 max-w-xl text-[15px] font-light leading-[1.8] ${
            light ? 'text-cream/80' : 'text-royal/70'
          }`}
        >
          {lede}
        </p>
      )}
    </Reveal>
  );
}
